var $d6eb2dcb210fb666$exports = {};
"use strict";
const $d6eb2dcb210fb666$var$ReferrerKey = "referrer";
const $d6eb2dcb210fb666$var$wixDomains = [
    "wix.com",
    "wix.wearebookable.com"
];
const $d6eb2dcb210fb666$var$wordpressDomains = [
    "wordpress.org"
];
const $d6eb2dcb210fb666$var$instagramDomains = [
    "instagram.com"
];
const $d6eb2dcb210fb666$var$referrers = {
    wix: "wix",
    wordpress: "wordpress",
    instagram: "instagram"
};
const $d6eb2dcb210fb666$var$queryParams = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop)=>searchParams.get(prop)
});
const $d6eb2dcb210fb666$var$referrerParam = $d6eb2dcb210fb666$var$queryParams.referrer?.toLowerCase();
let $d6eb2dcb210fb666$var$documentReferrer = null;
if ($d6eb2dcb210fb666$var$wixDomains.some(function(domain) {
    return document.referrer.includes(domain);
})) $d6eb2dcb210fb666$var$documentReferrer = $d6eb2dcb210fb666$var$referrers.wix;
else if ($d6eb2dcb210fb666$var$wordpressDomains.some(function(domain) {
    return document.referrer.includes(domain);
})) $d6eb2dcb210fb666$var$documentReferrer = $d6eb2dcb210fb666$var$referrers.wordpress;
else if ($d6eb2dcb210fb666$var$instagramDomains.some(function(domain) {
    return document.referrer.includes(domain);
})) $d6eb2dcb210fb666$var$documentReferrer = $d6eb2dcb210fb666$var$referrers.instagram;
if (Object.keys($d6eb2dcb210fb666$var$referrers).includes($d6eb2dcb210fb666$var$referrerParam)) localStorage.setItem($d6eb2dcb210fb666$var$ReferrerKey, $d6eb2dcb210fb666$var$referrerParam);
else if ($d6eb2dcb210fb666$var$documentReferrer !== null) localStorage.setItem($d6eb2dcb210fb666$var$ReferrerKey, $d6eb2dcb210fb666$var$documentReferrer);
else if (document.referrer.indexOf(location.protocol + "//" + location.host) === -1) localStorage.removeItem($d6eb2dcb210fb666$var$ReferrerKey);
window.dataLayer = window.dataLayer || [];
function $d6eb2dcb210fb666$var$gtag() {
    dataLayer.push(arguments);
}
$d6eb2dcb210fb666$var$gtag("js", new Date());
$d6eb2dcb210fb666$var$gtag("config", "G-7W9FBH2XYR");
document.addEventListener("click", function(event) {
    if (event.target.tagName === "A") {
        if (event.target.href.includes("dashboard.wearebookable.com")) {
            const href = new URL(event.target.href);
            const referrer = localStorage.getItem($d6eb2dcb210fb666$var$ReferrerKey);
            if (referrer) href.searchParams.append($d6eb2dcb210fb666$var$ReferrerKey, referrer);
            event.preventDefault();
            if (event.target.href === "https://dashboard.wearebookable.com/register") $d6eb2dcb210fb666$var$gtag("event", "get_started_link_click", {
                link_text: event.target.innerText,
                link_url: event.target.href
            });
            window.location.href = href.href;
        }
    }
});


//# sourceMappingURL=bookable_com.bc0358d0.js.map
